<template>
  <div
    class="file-uploader"
    :class="classes"
  >
    <div class="button-container">
      <!-- <button type="button" class="primary-btn btn upload-btn">
                <img :src="url('/img/icons/upload.svg')" alt="Nahrať fotografiu" class="upload-icon">
                {{ $t('Upload photo', {number}) }}
            </button> -->
      <input
        :id="name"
        type="file"
        :name="name"
        accept=".jpg,.jpeg,image/*"
        @change="changeInput"
        @click="resetInput"
      >
    </div>
  </div>
</template>
<script>
import useFileUploader from './useFileUploader'
import { url } from '../../../../../helpers'

export default {
  props: {
    classes: {
      type: String,
      default: () => '',
    },
    name: {
      type: String,
      default: () => '',
    },
    number: {
      type: Number,
      default: () => 1,
    },
  },
  setup(props) {
    const {
      handleFiles,
    } = useFileUploader()

    return {
      handleFiles,
      url,
    }
  },
  methods: {
    changeInput(event) {
      if (this.handleFiles(event, this.number)) {
        this.$emit('uploaded-file')
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.button-container {
    position: relative;

    input {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        opacity: 0;
        cursor: pointer;
    }

    button {
        margin: 0 0 25px 0;
    }
}
</style>
